import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import toast from "react-hot-toast";
import { MdEmail, MdLock, MdVisibility, MdVisibilityOff } from "react-icons/md";
import doctorService from "../../Services/doctorService";
import logo from "../../assets/logo2.png";
import { MdArrowForward } from "react-icons/md";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

export default function Login() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [showPass, setShowPass] = useState(false);
  const [focused, setFocused] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.email || !form.password) {
      toast.error("Email and password are required");
      return;
    }
    setLoading(true);
    try {
      const res = await doctorService.login(form);
      if (res.responseCode === 200) {
        Cookies.set("doctor", JSON.stringify(res.doctor), { expires: 1 });
        toast.success("Login successful");
        // navigate("/dashboard");
        navigate("/dashboard", { replace: true });
      }
    } catch (error) {
      toast.error(error?.message || "Invalid email or password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex overflow-hidden"
      style={{ fontFamily: "'Poppins', sans-serif" }}>
        <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(24px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .fade-up { animation: fadeUp 0.7s ease both; }
      `}</style>
      <div
        className="hidden md:flex w-[45%] flex-col justify-between p-12 relative overflow-hidden"
        style={{
          background: "linear-gradient(155deg,  #90E0EF  0%, #03045E 100%)",
        }}
      >
        <div className="absolute -top-28 -right-28 w-[420px] h-[420px] rounded-full bg-white/[0.04] pointer-events-none" />
        <div className="absolute -bottom-20 -left-20 w-[300px] h-[300px] rounded-full bg-white/[0.04] pointer-events-none" />


        <div className="flex items-center z-10">
          <img
            src={logo}
            alt="Hospital Logo"
            className="w-28 h-28 object-contain scale-125"
          />
          <span className="text-white text-xl tracking-wide pb-2 font-semibold"
    style={{ fontFamily: "'Poppins', sans-serif" }}>
            Hospital Management System
          </span>
        </div>

        <div className="relative z-10">
          <h1 className="text-white text-[42px] leading-[1.15] mb-5 font-semibold"
            style={{ fontFamily: "'Poppins', sans-serif" }}>
           Empowering doctors,
            <br />
             <span
    className="text-[#215187]"
    style={{ fontFamily: "'Poppins', sans-serif" }}
  >
    improving care,
  </span>
            <br />
            every day.
          </h1>
          <p  className="text-white/55 text-[15px] leading-[1.7] max-w-[300px] font-light">
            Manage patients, appointments, and staff smarter — all in one platform.
          </p>
        </div>

        <div className="flex gap-9 relative z-10">
          {[
            { num: "24+", label: "Today's Appointments" },
            { num: "1K+", label: "Patients Treated" },
            { num: "500+", label: "Prescriptions Issued" },
          ].map((s, i) => (
            <React.Fragment key={s.label}>
              {i > 0 && <div className="w-px bg-white/15 self-stretch" />}
              <div className="flex flex-col gap-1">
                <span className="text-white text-[26px] font-semibold"
                  style={{ fontFamily: "'Poppins', sans-serif" }}>{s.num}</span>
                <span  className="text-[11px] text-white/40 uppercase tracking-[0.8px] font-medium">
                  {s.label}
                </span>
              </div>
            </React.Fragment>
          ))}
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center px-8 py-10 bg-white">
        <div className="w-full max-w-[420px] fade-up">
          <h2 className="text-[#0a2540] text-[32px] mb-1 font-semibold"
            style={{ fontFamily: "'Poppins', sans-serif" }}>
            Welcome back
          </h2>
          <p className="text-[#8a9bb0] text-sm mb-10">
            Sign in to your Doctor Portal
          </p>

          <form onSubmit={handleSubmit}>
            <div className="mb-5 relative">
              <label className="block text-[11px] font-semibold tracking-[0.8px] uppercase text-[#4a6080] mb-2">
                Email Address
              </label>
              <div className="relative flex items-center">
                <span
                  className={`absolute left-4 flex items-center pointer-events-none transition-colors ${
                    focused === "email" ? "text-[#e96f1f]" : "text-[#8a9bb0]"
                  }`}
                >
                  <MdEmail size={18} />
                </span>
                <input
                  className="w-full pl-11 pr-11 py-[14px] border-[1.5px] border-[#dde4ed] rounded-xl text-[15px] text-[#0a2540] bg-white outline-none transition-all placeholder:text-[#b0bcc9] focus:border-[#e96f1f] focus:shadow-[0_0_0_4px_rgba(233,111,31,0.1)]"
                style={{ fontFamily: "'Poppins', sans-serif" }}
                  name="email"
                  placeholder="Enter your email"
                  value={form.email}
                  onChange={handleChange}
                  onFocus={() => setFocused("email")}
                  onBlur={() => setFocused("")}
                />
              </div>
            </div>

            <div className="mb-5 relative">
              <label className="block text-[11px] font-semibold tracking-[0.8px] uppercase text-[#4a6080] mb-2">
                Password
              </label>
              <div className="relative flex items-center">
                <span
                  className={`absolute left-4 flex items-center pointer-events-none transition-colors ${
                    focused === "password" ? "text-[#e96f1f]" : "text-[#8a9bb0]"
                  }`}
                >
                  <MdLock size={18} />
                </span>
                <input
                 className="w-full pl-11 pr-11 py-[14px] border-[1.5px] border-[#dde4ed] rounded-xl text-[15px] text-[#0a2540] bg-white outline-none transition-all placeholder:text-[#b0bcc9] focus:border-[#e96f1f] focus:shadow-[0_0_0_4px_rgba(233,111,31,0.1)]"
                style={{ fontFamily: "'Poppins', sans-serif" }}
                  type={showPass ? "text" : "password"}
                  name="password"
                  placeholder="Enter your password"
                  value={form.password}
                  onChange={handleChange}
                  onFocus={() => setFocused("password")}
                  onBlur={() => setFocused("")}
                />
                <button
                  type="button"
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-[#8a9bb0] hover:text-[#2F6DB4] transition-colors p-1 rounded-md"
                  onClick={() => setShowPass(!showPass)}
                  tabIndex={-1}
                >
                  {showPass ? <MdVisibilityOff size={18} /> : <MdVisibility size={18} />}
                </button>
              </div>
            </div>

            <button
  type="submit"
  disabled={loading}
  className="w-full py-[15px] rounded-xl text-white text-base font-semibold tracking-[0.3px] transition-all disabled:opacity-65 disabled:cursor-not-allowed hover:enabled:-translate-y-px"
            style={{
              background: "linear-gradient(135deg, #2F6DB4 0%, #255A8C 100%)",
               boxShadow: "0 2px 10px #255A8C",
              fontFamily: "'Poppins', sans-serif",
            }}
>
  <span className="flex items-center justify-center gap-2.5">
    {loading ? (
      <>
        <AiOutlineLoading3Quarters
          size={18}
          className="animate-spin"
        />
        Signing in...
      </>
    ) : (
      <>
        <span>Sign In</span>
        <MdArrowForward size={18} />
      </>
    )}
  </span>
</button>
          </form>

          {/* <p className="text-center text-[#b0bcc9] text-xs mt-8">
            © {new Date().getFullYear()} Hospital Management System
          </p> */}
        </div>
      </div>
    </div>
  );
}